import { resolveDepositExecution } from '../components/utils/resolveSwapFlow.js';
export const gaslessAuthorizationKey = (swapId) => `/swaps/${swapId}/authorize`;
// Route can use the gasless (sign-to-deposit) flow. Excludes the user's gasless toggle.
export function isGaslessCapableRoute(input) {
    const sourceTokenIsNative = !input.sourceTokenContract;
    const usesPermit2 = input.gaslessStandard?.toLowerCase() === 'permit2';
    return input.depositMethod === 'wallet'
        && !!input.supportsGaslessDeposit
        && !sourceTokenIsNative
        && !usesPermit2
        && input.gaslessStandard !== 'erc2612'
        && !!input.sourceIsSupported
        && !!input.sourceAddress;
}
// EIP-3009 supports both execution modes. A sign-only snapshot may precede
// publication, so only explicit steps/standards identify the lane.
export function isGaslessDepositWorkflow(actions) {
    const { kind, evidence } = resolveDepositExecution(actions);
    // Publication proves a self-paid rail even when its atomic/legacy identity is missing.
    if (evidence === 'ambiguous-publication')
        return false;
    return kind === 'unresolved' ? undefined : kind === 'gasless-deposit';
}
export function isGaslessAuthorizationSubmitted(authorization) {
    if (!authorization)
        return false;
    if (authorization.transaction?.status === 'failed')
        return false;
    return !!authorization.transaction?.transaction_hash
        || authorization.status === 'published' || authorization.status === 'completed';
}
// A fetched accepted sign action can probe the authorization endpoint to resolve
// an ambiguous gasless lane on a browser with no local action receipt.
// Explicit self-paid actions override every saved signature receipt.
export function isGaslessAuthorizationForWorkflow(authorization, actions) {
    const gasless = isGaslessDepositWorkflow(actions);
    if (gasless === false)
        return false;
    const acceptedSignAction = actions?.some(action => (action.step === 'sign' || action.type === 'sign')
        && (action.status === 'pending' || action.status === 'completed')) ?? false;
    return authorization?.kind === 'gasless' || gasless === true || acceptedSignAction;
}
